"use client";

import log from "logbeacon";
import ManageBillingModalContent from "./ManageBillingModalContent";
import { ManageBillingModalContentProps, SubscriptionListItem } from "./types";
import { EdgenModalCreateAble } from "@/src/components/EdgenModal";

const handleClose = () => {
  log.debug("[文案]click", {
    target: "close_billing_modal",
    location: "billing_modal",
  });
  EdgenModalCreateAble.end(false);
};

/**
 * 以 EdgenModalCreateAble 形式打开管理账单弹窗，复用全局 EdgenModalCreateAble.Root
 * @param props.currentPlan 当前计划数据
 * @param props.refetchPlanInfo 刷新计划信息的回调
 * @returns Promise<boolean> 关闭时为 false（本弹窗无确认/取消区分）
 */
export const openManageBillingModal = (
  params: Pick<ManageBillingModalContentProps, "view" | "allowBack"> = {},
) => {
  return new Promise<{
    action: "close" | "CancelSubscription";
    payload?: SubscriptionListItem;
  }>((resolve) => {
    const result = EdgenModalCreateAble.call({
      destroyOnClose: true,
      className: "text-white md:w-[560px] h-[492px] max-w-full rounded-2xl",
      closeStyle: {
        right: 0,
        top: 0,
      },
      showClose: true,
      contentStyle: {
        padding: 0,
        maxHeight: "492px",
        minHeight: "320px",
      },
      children: (
        <ManageBillingModalContent
          {...params}
          onClose={() => {
            EdgenModalCreateAble.end(result, false);
            resolve({ action: "close" });
          }}
          onCancelSubscription={(params) => {
            EdgenModalCreateAble.end(result, false);
            resolve({ action: "CancelSubscription", payload: params });
          }}
        />
      ),
    });
  });
};

export const closeManageBillingModal = handleClose;
